import React from 'react'
import '../Footer/Style.css'

const Footer = () => {
  return (
    <div className='footerContainer'>
        <p className='footerName'>© 2026 CJJBF. All rights reserved.</p>
    </div>
  )
}

export default Footer;
